module.exports = __webpack_public_path__ + "static/img/order.30c9ccd8.png";